import {
  GRETA_AI_CHAT_SOURCES,
  GretaAIChatSource,
  GretaAIChatStatus,
} from './GretaAIChat.constants'

export function getIsGretaAIChatNewChat(activeChatId) {
  return activeChatId === null
}

export function getGretaAIChatSelectedSource({
  activeChat,
  activeChatId,
  newChatSource,
}) {
  return getIsGretaAIChatNewChat(activeChatId)
    ? newChatSource
    : getGretaAIChatChatSource(activeChat)
}

export function getIsGretaAIChatFinanceSource(source) {
  return source === GretaAIChatSource.Finance
}

// Without the choice an empty chat is CRM; a chat with a question keeps its own source.
export function getGretaAIChatOpenSource({
  isPinned,
  isSourceChoiceEnabled,
  source,
}) {
  return isSourceChoiceEnabled || isPinned ? source : GretaAIChatSource.Crm
}

export function getIsGretaAIChatSourceUnavailableStatus(status) {
  return status === GretaAIChatStatus.SourceUnavailable
}

export function getIsGretaAIChatSourceOutage({ source, status }) {
  return (
    getIsGretaAIChatFinanceSource(source) &&
    getIsGretaAIChatSourceUnavailableStatus(status)
  )
}

export function getIsGretaAIChatSourcePinned({ activeChatId, messages }) {
  return !getIsGretaAIChatNewChat(activeChatId) || messages.length > 0
}

export function getGretaAIChatOtherSource(source) {
  return GRETA_AI_CHAT_SOURCES.find(item => item !== source)
}

export function getGretaAIChatChatSource(chat) {
  return chat?.source ?? GretaAIChatSource.Crm
}

export function getCanGretaAIChatSwitchSource({
  isLimitReached,
  isPinned,
  isSendPending,
  isSourceChoiceEnabled,
}) {
  return isSourceChoiceEnabled && !isPinned && !isLimitReached && !isSendPending
}

// A chat whose source is off stays read-only, so its last question offers no retry;
// in an outage the retry belongs to the notice.
export function getGretaAIChatSourceMessages({
  isSourceOff,
  isSourceOutage,
  messages,
}) {
  return isSourceOff || isSourceOutage
    ? messages.map(message =>
        message.canRetry ? { ...message, canRetry: false } : message
      )
    : messages
}

export function getIsGretaAIChatSourceSwitchShown({
  isLocked,
  isSourceChoiceEnabled,
}) {
  return isSourceChoiceEnabled && !isLocked
}

export function getIsGretaAIChatSourceChoiceShown({
  isPinned,
  isProjectsPageShown,
  isSourceChoiceEnabled,
}) {
  return isSourceChoiceEnabled && !isPinned && !isProjectsPageShown
}

export function getHasGretaAIChatSourceSwitched(sourceSwitchCount) {
  return sourceSwitchCount > 0
}
